import { FocusEventHandler, forwardRef, memo, MouseEventHandler } from "react";
import classnames from "classnames";

import { ReactComponent as Calendar } from "./images/calendar.svg";

import styles from "./style.module.scss";

type CalendarButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>,
  onBlur?: FocusEventHandler<HTMLButtonElement>
  name?: string,
  className?: string,
  disabled?: boolean
}
const CalendarButton = memo<CalendarButtonProps>(forwardRef<HTMLButtonElement, CalendarButtonProps>(((props, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={classnames(styles.root, props.className)}
      onClick={props.onClick}
      onBlur={props.onBlur}
      disabled={props.disabled}
      name={props.name}
    >
      <Calendar width={20} height={20} />
    </button>
  );
})));

export default CalendarButton;
